import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";
import "./styles.scss";

const autoCompleteFor = (name, type) => {
  if (type === "email") return "email";
  if (name === "name" || name === "fullname") return "name";
  if (name === "linkedin") return "url";
  return undefined;
};

export const FieldInput = ({ label, name, ...props }) => (
  <>
    {label && <label htmlFor={`field-${name}`}>{label}</label>}
    <Field
      id={`field-${name}`}
      name={name}
      autoComplete={autoCompleteFor(name, props.type)}
      spellCheck={props.type === "email" ? false : undefined}
      {...props}
      className="fa_form_input"
    />
    <ErrorMessage
      component="span"
      name={name}
      className="error_feedback"
      role="alert"
    />
  </>
);

FieldInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["email", "text"]),
  as: PropTypes.oneOf(["textarea"]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};
